import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const { t } = useTranslation('triggerCalls')
  return (
    <Fragment>
      <Separator weight={12} />
      <Grid justify="space-between" align="center" gutter={0.4}>
        <Col>
          <Title size="h2" color="dark3" noWrap>
            {t('title')}
          </Title>
        </Col>
        <Col flex={1} />
      </Grid>

      <Separator weight={2} />
    </Fragment>
  )
}

export default PageHeader
